import { Font } from '@react-pdf/renderer';

export const PDF_FONT_FAMILY = 'Open Sans';

const OPEN_SANS_CDN = 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts';

let registered = false;

/** Open Sans carries the Polish diacritics; every PDF shares one registration. */
export function registerPdfFonts(): void {
  if (registered) return;
  Font.register({
    family: PDF_FONT_FAMILY,
    fonts: [
      { src: `${OPEN_SANS_CDN}/open-sans-regular.ttf`, fontWeight: 400 },
      {
        src: `${OPEN_SANS_CDN}/open-sans-italic.ttf`,
        fontWeight: 400,
        fontStyle: 'italic',
      },
      { src: `${OPEN_SANS_CDN}/open-sans-600.ttf`, fontWeight: 600 },
      { src: `${OPEN_SANS_CDN}/open-sans-700.ttf`, fontWeight: 700 },
    ],
  });
  Font.registerHyphenationCallback((word) => [word]);
  registered = true;
}
